import _request from '@/utils/request';
import { _getQuerystr } from '@/utils/commonUtils';

// 获取绑定的咨询师列表
export async function bindList() {
  const url = `/staff/consultant/bindList`;
  return await _request({
    method: 'GET',
    url
  });
}
// 根据当前员工，返回推荐咨询师列表
export async function getSuggestConsultants() {
  const url = `/staff/suggest`;
  return await _request({
    method: 'GET',
    url,
    type: 'hideError'
  });
}

// 查询咨询师排班日历
export async function patientGetConsultantScheduling(consultantId, params) {
  return await _request({
    method: 'GET',
    url: `/staff/consultant/${consultantId}/scheduling${_getQuerystr(params)}`
  });
}

// 添加与咨询师的预约
export async function patientAddConsultantAppoint(consultantId, data) {
  return await _request({
    method: 'POST',
    url: `/staff/consultant/${consultantId}/appoint`,
    data
  });
}

// [员工]查询最新的心理成长计划
export async function getStaffHealthReport() {
  const url = `/staff/getLatestHealthReport`;
  return await _request({
    method: 'GET',
    url
  });
}


// 员工查询聊天记录
export async function patientGetChatMsg(params) {
  return await _request({
    method: 'GET',
    url: `/staff/chat/msgPage${_getQuerystr(params)}`
  });
}

// 查询员工工单列表
export async function getStaffWorkOrders(params) {
  return await _request({
    method: 'GET',
    url: `/staff/workOrders${_getQuerystr(params)}`
  });
}


// 患者聊天文件上传
export async function patientUploadChatFile(resourceType, data) {
  return await _request({
    method: 'POST',
    url: `/staff/upload/${resourceType}`,
    data,
    type: 'upload'
  });
}

// 患者聊天文件上传v2
export async function patientUploadChatFileV2(resourceType, data) {
  return await _request({
    method: 'POST',
    url: `/staff/upload/v2/${resourceType}`,
    data,
    type: 'upload'
  });
}

// 员工获取 RTC token
// 参数 channelType    预约APPOINT   默认DEFAULT
export async function getPatientRTCToken(params) {
  const url = `/staff/RTC/createToken${_getQuerystr(params)}`
  return await _request({
    method: 'GET',
    url
  });
}

// 员工登录
export async function loginByPatient(data) {
  const url = `/staff/autoRegisterLogin`;
  return await _request({
    method: 'POST',
    url,
    data
  });
}

// 设置员工基本信息，仅可设置一次
export async function setPatientBaseInfo(data) {
  const url = `/staff/info`;
  return await _request({
    method: 'POST',
    url,
    data
  });
}
// 员工发送短信验证码 telephone
export async function sendPatientVerifyCode(telephone) {
  const url = `/staff/sendVerifyCode/${telephone}`;
  return await _request({
    method: 'POST',
    url
  });
}

// 员工查询匹配量表
export async function initMatchQuestionnaireUrl() {
  const url = `/staff/initMatchQuestionnaireUrl`
  return await _request({
    method: 'GET',
    url
  });
}


// 员工绑定咨询师
export async function bindConsultant(consultantId) {
  const url = `/staff/consultant/${consultantId}/bind`;
  return await _request({
    method: 'POST',
    url
  });
}

// 咨询师查看 员工基本信息
export async function getPatientBaseInfo(id) {
  const url = `/staff/info?authId=${id}`;
  return await _request({
    method: 'GET',
    url
  });
}

// 员工取消预约
export async function patientDeleteAppoint(appointId) {
  return await _request({
    method: 'DELETE',
    url: `/staff/appoint/${appointId}`
  });
}


// 员工通过authId查询咨询师基本信息
export async function patientGetDoctorInfo(id) {
  const url = `/staff/consultant/info?authId=${id}`;
  return await _request({
    method: 'GET',
    url
  });
}

// 员工通过authid查询基本信息
export async function patientGetSelfInfo(id) {
  const url = `/staff/info?authId=${id}`;
  return await _request({
    method: 'GET',
    url
  });
}

// 获取量表作答的链接地址
export async function getFormH5Url(taskId, seq) {
  const url = `/staff/task/formUrl?taskId=${taskId}&seq=${seq}`;
  return await _request({
    method: 'GET',
    url
  });
}

export async function getFormCallbackResult(taskId) {
  const url = `/staff/task/formCallbackResult?taskId=${taskId}`;
  return await _request({
    method: 'GET',
    url
  });
}

// 来访者端获取所有量表信息
export async function getStaffFormList(params) {
  const url = `/staff/task/formList${_getQuerystr(params)}`;
  return await _request({
    method: 'GET',
    url,
  });
}

// 查询AI多模态量表
export async function getStaffAIFormList() {
  const url = `/staff/aiRecord/page`;
  return await _request({
    method: 'GET',
    url,
  });
}

// 来访者查询量表list
export async function getStaffQuestionnaireList() {
  const url = `/staff/questionnaire/list`;
  return await _request({
    method: 'GET',
    url
  });
}

// 来访者根据taskId查询jsonFormData
export async function getStaffForm(params) {
  const url = `/staff/task${_getQuerystr(params)}`;
  return await _request({
    method: 'GET',
    url
  });
}

// [用户]创建自选量表task,返回url
export async function createStaffTask(data) {
  const url = '/staff/task/create';
  return await _request({
    method: 'POST',
    url,
    data
  })
}

// [员工] 分页查询咨询评价
export async function getStaffEvaluationList(params) {
  const url = `/staff/consult/pageEvaluation${_getQuerystr(params)}`;
  return await _request({
    method: 'GET',
    url,
  })
}

// [员工] 查询咨询评价
export async function getStaffEvaluation(evaluationId) {
  const url = `/staff/consult/evaluation/${evaluationId}`;
  return await _request({
    method: 'GET',
    url,
  })
}

// [员工] 新增咨询评价
export async function createEvaluation(params) {
  const url = `/staff/consult/createEvaluation`;
  return await _request({
    method: 'POST',
    url,
    data: params,
  })
}

// [员工] 分页查询咨询记录（recode）
export async function getStaffConsultRecode(params) {
  const url = `/staff/consult/pageRecode${_getQuerystr(params)}`;
  return await _request({
    method: 'GET',
    url,
  })
}

// [员工] 咨询完成确认
export async function staffConsultCompleted(params) {
  const url = `/staff/consult/consultRecodeCompleted`;
  return await _request({
    method: 'POST',
    url,
    data: params,
  })
}

// [员工]查询咨询详情
export async function staffGetConsultantInfo(consultRecodeId) {
  const url = `/staff/consult/${consultRecodeId}`;
  return await _request({
    method: 'GET',
    url,
  })
}

// [员工] 关闭音视频房间
export async function staffLeaveRoom(params) {
  const url = `/staff/appoint/leaveRoom`;
  return await _request({
    method: 'POST',
    url,
    data: params,
  })
}

// [员工] 撤回消息
export async function staffChatWithdraw(params) {
  const url = `/staff/chat/withdraw`;
  return await _request({
    method: 'POST',
    url,
    data: params,
  })
}

// [员工] 撤回消息V2
export async function staffChatWithdrawV2(chatMsgId) {
  const url = `/staff/chat/v2/withdraw/${chatMsgId}`;
  return await _request({
    method: 'POST',
    url,
  })
}

// [员工] 查询聊天记录
export async function staffGetChatMsg(params) {
  const url = `/staff/chat/msgPage${_getQuerystr(params)}`;
  return await _request({
    method: 'GET',
    url,
  })
}

// [来访者] 查询设置通知详情
export async function getStaffSettingInfo() {
  const url = `/staff/getSettingInfo`;
  return await _request({
    method: 'GET',
    url,
  })
}


// [来访者] 修改设置通知详情
// params: evaluationPushCycle
export async function updateStaffSetting(params) {
  const url = `/staff/updateSetting`;
  return await _request({
    method: 'POST',
    url,
    data: params
  })
}

// [来访者] 完成测评提交
export async function completeStaffEvaluation(params) {
  const url = `/staff/completeEvaluation`;
  return await _request({
    method: 'POST',
    url,
    data: params
  })
}

// [来访者] 查询tag列表
export async function getStaffTagList() {
  const url = `/staff/getTagList`;
  return await _request({
    method: 'GET',
    url,
  })
}

// [来访者] 查询用户首页文章推荐列表
export async function getStaffRecommendList(params) {
  const url = `/staff/getRecommendList${_getQuerystr(params)}`;
  return await _request({
    method: 'GET',
    url,
  })
}

// [来访者] 查询用户首页文章推荐列表
export async function getStaffAllRecommendList(params) {
  const url = `/staff/getAllRecommendList${_getQuerystr(params)}`;
  return await _request({
    method: 'GET',
    url,
  })
}

// [来访者] 查询用户首页文章推荐列表
export async function getNeedFirstEvaluation() {
  const url = `/staff/needFirstEvaluation`;
  return await _request({
    method: 'GET',
    url,
  })
}

// [来访者] 获取DataEnc接口
export async function getStaffDataEnc(params) {
  const url = `/staff/getDataEnc`;
  return await _request({
    method: 'GET',
    url,
  })
}

// [国药-员工]查询量表list
export async function getSFDAQuestionnaireList() {
  const url = `/staff/SFDA/questionnaire/list`;
  return await _request({
    method: 'GET',
    url
  });
}

// [国药-员工]上传关爱信息
export async function addStaffCareFor(params) {
  const url = `/staff/SFDA/addStaffCareFor`;
  return await _request({
    method: 'POST',
    url,
    data: params
  })
}

// 匿名登录--使用dataEnc
/**
 * 
 * @param {*} data organizationId dataEnc
 * @returns 
 */
export async function loginByDataEnc(data) {
  const url = `/staff/loginByDataEnc`;
  return await _request({
    method: 'POST',
    url,
    data
  });
}

/* 
 * 学号登录--使用学号+密码
 * @param {*} data: account dataEnc
 * @returns 
 */
export async function loginByAccount(data) {
  const url = `/staff/loginByAccount`;
  return await _request({
    method: 'POST',
    url,
    data
  });
}

/**
 *  打开咨询师的聊天窗口 时调用 动作触发
 * @param {*} data: triggerType  chatAuthId time
 * @returns 
 */
export async function staffTrigger(data) {
  const url = `/staff/trigger`;
  return await _request({
    method: 'POST',
    url,
    data
  });
}

// 多模态心理测评增加参数
export async function addAIRecord(params) {
  const url = `/staff/addAIRecord`;
  return await _request({
    method: 'POST',
    url,
    data: params
  });
}

// 验证手机号码
export async function checkVerifyCode(telephone, params) {
  const url = `/staff/checkVerifyCode/${telephone}${_getQuerystr(params)}`;
  return await _request({
    method: 'GET',
    url,
  })
}
// 更新基础信息，目前仅手机号码
export async function updateStaffInfo(params) {
  const url = `/staff/update`;
  return await _request({
    method: 'POST',
    url,
    data: params
  })
}

// [来访者] 清除未读消息
export async function clientClearChat(params) {
  const url = `/staff/chat/clear`;
  return await _request({
    method: 'POST',
    url,
    data: params
  })
}

// [来访者]验证注册码
export async function checkRegisterCode(params) {
  const url = `/staff/v2/checkRegisterCode${_getQuerystr(params)}`;
  return await _request({
    method: 'GET',
    url
  });
}
// [来访者]校验手机号
export async function checkTelephone(params) {
  const url = `/staff/v2/checkTelephone${_getQuerystr(params)}`;
  return await _request({
    method: 'GET',
    url
  });
}

// [来访者]登录
export async function loginV2(params) {
  const url = `/staff/v2/login${_getQuerystr(params)}`;
  return await _request({
    method: 'GET',
    url
  });
}

// [来访者]关联已有账号
export async function linkWithCode(params) {
  const url = `/staff/v2/linkWithCode`;
  return await _request({
    method: 'POST',
    url,
    data: params,
  });
}

// [来访者]注册新账号
export async function staffRegisterAccount(params) {
  const url = `/staff/v2/registerWithCode`;
  return await _request({
    method: 'POST',
    url,
    data: params,
  })
}

// [来访者]注册子账号
export async function staffRegisterSubAccount(params) {
  const url = `/staff/v2/registerSubAccount`;
  return await _request({
    method: 'POST',
    url,
    data: params,
  })
}

// [来访者]关联子账号
export async function staffBindSubAccount(params) {
  const url = `/staff/v2/linkSubAccount`;
  return await _request({
    method: 'POST',
    url,
    data: params,
  })
}

// [来访者]查询子账号列表
export async function staffGetSubList() {
  const url = `/staff/listSub`;
  return await _request({
    method: 'GET',
    url
  })
}

// [来访者] 删除子账号
export async function staffDeleteSubAccount(params) {
  const url = '/staff/v2/deleteSubAccount';
  return await _request({
    method: 'POST',
    url,
    data: params
  })
}

// [来访者]预约列表
export async function getStaffAppointmentList(params) {
  const url = `/staff/appointment/page${_getQuerystr(params)}`;
  return await _request({
    method: 'GET',
    url
  });
}

// [来访者]预约详情
export async function getStaffAppointmentDetail(id) {
  const url = `/staff/appointment/${id}`;
  return await _request({
    method: 'GET',
    url
  });
}

// [来访者]检查可以开启新预约
export async function checkCanAddAppointment() {
  const url = '/staff/appointment/checkCanAdd';
  return await _request({
    method: 'GET',
    url
  })
}

// [来访者]新增预约
export async function addAppointment(params) {
  const url = '/staff/appointment/add';
  return await _request({
    method: 'POST',
    url,
    data: params
  })
}

// [来访者]取消预约
export async function cancelAppointment(id) {
  const url = `/staff/appointment/${id}/cancel`;
  return await _request({
    method: 'POST',
    url,
  })
}

// [来访者]根据tenantId 查询配置
export async function getStaffConfigByTenantId(params) {
  const url = `/staff/getConfigByTenant${_getQuerystr(params)}`;
  return await _request({
    method: 'GET',
    url
  })
}

export async function getPreviousSessions_deprecated(consultantId, pageNo, pageSize) {
  const url = `/staff/chat/sessions?consultantId=${consultantId}&pageNo=${pageNo}&pageSize=${pageSize}`;
  return await _request({
    method: 'GET',
    url,
  });
}

// /staff/task/list
export async function getStaffTaskList() {
  const url = `/staff/task/list`;
  return await _request({
    method: 'GET',
    url,
  });
}

// /staff/task/latestAiReport
export async function getStaffLatestAiReport() {
  const url = `/staff/task/latestAiReport`;
  return await _request({
    method: 'GET',
    url,
  });
}

// [来访者]根据formId获取评估表单
export async function getEvaluationForm(formId) {
  const url = `/evaluation/form/?shufuFormId=${formId}`;
  return await _request({
    method: 'GET',
    url,
  });
}

// [来访者]获取评估表单
export async function getEvaluationForms() {
  const url = `/evaluation/forms`;
  return await _request({
    method: 'GET',
    url,
  });
}

// [来访者]提交评估表单
export async function submitEvaluationForm(data) {
  const url = `/evaluation/replyToForm`;
  return await _request({
    method: 'POST',
    url,
    data
  });
}

// [来访者]根据reportId获取评估报告
export async function getEvaluationReport(reportId) {
  const url = `/evaluation/report/${reportId}`;
  return await _request({
    method: 'GET',
    url,
  });
}

// [来访者]获取评估报告列表
export async function getEvaluationReports() {
  const url = `/evaluation/reports`;
  return await _request({
    method: 'GET',
    url,
  });
}

// [来访者]获取最新快速测评报告
export async function getLastQuickTestReport() {
  const url = `/evaluation/reports/lastQuickTest`;
  return await _request({
    method: 'GET',
    url,
  });
}

// [来访者]根据formId获取最新评估报告
export async function getLastEvaluationReport(formId, params) {
  const url = `/evaluation/reports/last/${formId}${_getQuerystr(params)}`;
  return await _request({
    method: 'GET',
    url,
  });
}

// [来访者]根据reportId获取AI报告
export async function getAIReport(reportId) {
  const url = `/evaluation/aiReport/${reportId}`;
  return await _request({
    method: 'GET',
    url,
  });
}

// [来访者] 打开工单
export async function openWorkOrder() {
  const url = `/staff/openWorkOrder`;
  return await _request({
    method: 'POST',
    url,
  });
}

// [来访者] 获取工单消息列表
export async function getWorkOrderMessages(params) {
  const url = `/staff/workOrder/messages${_getQuerystr(params)}`;
  return await _request({
    method: 'GET',
    url,
  });
}

// [员工] 获取团队活动当前排期列表
export async function getTeamActivityCurrentSchedule() {
  return await _request({
    method: 'GET',
    url: '/staff/teamActivity/currentSchedule'
  });
}

// [来访者] 启动工单AI聊天 - 非流式调用（用于初始化）
export async function startWorkOrderAIChat(workOrderId) {
  const url = `/staff/workOrder/aiChat`;
  return await _request({
    method: 'POST',
    url,
    data: {
      messages: [],
      workOrderId: workOrderId
    }
  });
}

// [来访者] 完成工单
export async function staffCompleteWorkOrder(workOrderId) {
  const url = `/staff/workOrder/complete/${workOrderId}`;
  return await _request({
    method: 'POST',
    url,
  });
}

// [来访者] 重新打开工单
export async function reopenWorkOrder(workOrderId) {
  const url = `/staff/workOrder/reopen/${workOrderId}`;
  return await _request({
    method: 'POST',
    url,
  });
}

export async function enrollTeamActivity(teamActivityScheduleItemId) {
  return await _request({ method: 'POST', url: `/staff/teamActivity/enroll?teamActivityScheduleItemId=${teamActivityScheduleItemId}` });
}

export async function cancelTeamActivity(teamActivityScheduleItemId) {
  return await _request({ method: 'POST', url: `/staff/teamActivity/cancel?teamActivityScheduleItemId=${teamActivityScheduleItemId}` });
}

// 获取当前活动的促销页面
export async function getPromotionPage() {
  return await _request({
    method: 'GET',
    url: '/promotion/page'
  });
}

// [来访者] 预约列表 v2
export async function getAppointList(params) {
  const url = `/staff/appoint/list${_getQuerystr(params)}`;
  return await _request({ method: 'GET', url });
}

// /staff/registerLoginByDataEnc
export async function registerLoginByDataEnc (data) {
  const url = `/staff/registerLoginByDataEnc`;
  return await _request({
    method: 'POST',
    url,
    data
  });
}

// GET/getAuthorizationToken 获取讯飞appkey配置
export async function getAuthorizationToken(params) {
  const url = `/getAuthorizationToken${_getQuerystr(params)}`;
  return await _request({
    method: 'GET',
    url,
  });
}

// 发送邮箱验证码
export async function sendEmailCode(data) {
  const url = `/staff/sendEMailVerifyCode`;
  return await _request({
    method: 'POST',
    url,
    data
  });
}

// [来访者] 接受AI服务协议
export async function acceptAiAgreements() {
  const url = `/staff/acceptAiAgreements`;
  return await _request({
    method: 'POST',
    url,
  });
}
